import {
  ConfigurationPanel,
  ConfigurationPanelBody,
  ConfigurationPanelHeader,
  ConfigurationPanelFooter,
} from "../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";

import ExternalApiForm from "./ExternalApiForm";
import useExternalApiForm from "./useExternalApiForm";

export default ExternalApiConfig;

function ExternalApiConfig(props) {
  const { node, closePanel, onSave, validationErrors } = props;

  const { formState, updateFormState, errors, validate } = useExternalApiForm(
    node.data,
    validationErrors
  );

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure External API </p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <ExternalApiForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end items-center gap-x-2">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
